   import styles from '../../SizeAndWeightStyles.module.css';
import Required from '../../Required/Required';
import NumberField from '../../NumberFields/NumberFields';

const AxleGroupWeight = ({ 
  axleGroup = {}, 
  dispatch = () => { console.error("No dispatch function provided") }, 
  sizeAndWeightId = "", 
  userId = "", 
  missingFields = [], 
  disabled = true, 
  updateAxleGroup = ()=>{console.error("No updateAxleGroup function provided")}
}) => {
  const { weight, id, axleGroupLimit, overLimit } = axleGroup;

  const updateGroupWeight = (val, action) => {
    dispatch({ type: action, payload: { axleGroupId: id, property: 'weight', value: +val } })
    updateAxleGroup({
      variables: {
        input: {
          axleGroupId: id,
          weight: +val,
          subtotal: +val,
          sizeAndWeightId,
          originatorId: userId,
          overLimit: +val - axleGroupLimit
        }
      }
    })
  }

  return (
    <div id={"axle-group-weight-container-" + axleGroup?.id} className={`${styles['flexColumn']}`}>
      <Required
        required={missingFields.some(field => field?.name === "weight")}
        message={missingFields.find(field => field?.name === "weight")?.error}
      >
        <NumberField
          id={"axle-group-weight-" + axleGroup?.id}
          value={weight}
          dispatch={dispatch}
          label={"Platform\xa0Weight"}
          handleBlur={updateGroupWeight}
          action={"UPDATE_AXLE_GROUP"}
          property={"weight"}
          lbs={true}
          payload={{ axleGroupId: id, property: 'weight' }}
          disabled={disabled}
        />
      </Required>
      <NumberField
        value={overLimit}
        label={`${overLimit > 0 ? "Over" : "Under"} Limit`}
        id={"axle-group-weight-difference-" + axleGroup?.id}
        disabled={true}
        lbs={true}
        bold={true}
        showColor={true}
      />
    </div>
  )
}

export default AxleGroupWeight;